import { twMergeExt } from '@/shared/utils/twMergeExt';
import { VariantProps } from 'class-variance-authority';
import { FC, useState } from 'react';
import { cvaItem, cvaItemSvg, cvaRoot } from './RatingStyles';

interface Props extends VariantProps<typeof cvaItemSvg> {
  value: number;
  className?: string;
  selectable?: boolean;
  onChange?: (value: number) => void;
}

const Rating: FC<Props> = ({ value, className, size, onChange, selectable = false }) => {
  const [hoveredValue, setHoveredValue] = useState<number>(0);
  const [selectedValue, setSelectedValue] = useState<number>(value);

  const handleClick = (index: number) => {
    setSelectedValue(index);
    if (onChange) {
      onChange(index);
    }
  };

  const handleMouseEnter = (index: number) => {
    setHoveredValue(index);
  };

  const handleMouseLeave = () => {
    setHoveredValue(0);
  };

  const renderStar = (index: number) => {
    const isFilled = index <= (hoveredValue || selectedValue);

    return (
      <div
        className={cvaItem({ size, selectable })}
        key={index}
        onClick={() => selectable && handleClick(index)}
        onMouseEnter={() => selectable && handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
      >
        <svg className={cvaItemSvg({ size })} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5446 1.00423C11.7221 0.612883 12.2779 0.612883 12.4554 1.00423L15.233 7.12983C15.3058 7.2903 15.4576 7.40062 15.6327 7.42024L22.3169 8.16904C22.7439 8.21688 22.9157 8.7455 22.5983 9.0352L17.6309 13.5698C17.5007 13.6886 17.4427 13.8671 17.4782 14.0397L18.8316 20.6281C18.918 21.049 18.4683 21.3757 18.0947 21.1634L12.247 17.8404C12.0938 17.7533 11.9062 17.7533 11.753 17.8404L5.90525 21.1634C5.53166 21.3757 5.08198 21.049 5.16845 20.6281L6.52181 14.0397C6.55726 13.8671 6.49926 13.6886 6.36913 13.5698L1.40169 9.0352C1.08433 8.7455 1.25609 8.21688 1.68312 8.16904L8.36726 7.42024C8.54235 7.40062 8.6942 7.2903 8.76696 7.12983L11.5446 1.00423Z"
            fill="#213D38"
            fillOpacity={0.16}
          />
          <mask
            id={`mask0_73_${index}`}
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="1"
            y="0"
            width="22"
            height="22"
          >
            <path
              d="M11.5446 1.00423C11.7221 0.612883 12.2779 0.612883 12.4554 1.00423L15.233 7.12983C15.3058 7.2903 15.4576 7.40062 15.6327 7.42024L22.3169 8.16904C22.7439 8.21688 22.9157 8.7455 22.5983 9.0352L17.6309 13.5698C17.5007 13.6886 17.4427 13.8671 17.4782 14.0397L18.8316 20.6281C18.918 21.049 18.4683 21.3757 18.0947 21.1634L12.247 17.8404C12.0938 17.7533 11.9062 17.7533 11.753 17.8404L5.90525 21.1634C5.53166 21.3757 5.08198 21.049 5.16845 20.6281L6.52181 14.0397C6.55726 13.8671 6.49926 13.6886 6.36913 13.5698L1.40169 9.0352C1.08433 8.7455 1.25609 8.21688 1.68312 8.16904L8.36726 7.42024C8.54235 7.40062 8.6942 7.2903 8.76696 7.12983L11.5446 1.00423Z"
              fill="#213D38"
            />
          </mask>
          <g mask={`url(#mask0_73_${index})`}>
            <rect
              y="-2"
              width={selectable ? (isFilled ? 24 : 0) : value >= index ? 24 : 24 * (value - (index - 1))}
              height="26"
              fill="#3DC869"
            />
          </g>
        </svg>
      </div>
    );
  };

  return <div className={twMergeExt(cvaRoot(), className)}>{[1, 2, 3, 4, 5].map(renderStar)}</div>;
};

export default Rating;
